module.exports = __webpack_public_path__ + "img/tq4.bd3498ea.png";